import axios from 'axios'
import { ApiConfig } from '@/config/ApiConfig'
import { MarketplaceConfig } from '@/config/MarketplaceConfig'

export default {
  namespaced: true,

  state: {
    status: 'idle',
    id: undefined,
    data: undefined,
  },
  getters: {
    getId: (state) => {
      return state.id || null
    },
    getData: (state) => {
      return state.data || null
    },
    getStatus: (state) => {
      return state.status
    },
    isLoading: (state) => {
      return state.status === 'busy' ?? false
    },
  },
  mutations: {
    STATUS_IDLE(state) {
      state.status = 'idle'
    },
    STATUS_BUSY(state) {
      state.status = 'busy'
    },
    STATUS_FAILED(state) {
      state.status = 'failed'
    },
    STATUS_SUCCEEDED(state) {
      state.status = 'succeeded'
    },
    REMEMBER_ID(state, payload) {
      state.id = payload
    },
    FORGET_ID(state) {
      state.id = undefined
    },
    REMEMBER_DATA(state, payload) {
      state.data = payload
    },
    FORGET_DATA(state) {
      state.data = undefined
    },
    SAVE_STATUS(state, payload) {
      state.data.user_status = payload
    },
    SAVE_BALANCE(state, payload) {
      state.data.profile.balance = payload
    },
  },
  actions: {
    async fetchData({ commit }, payload) {
      commit('STATUS_BUSY')
      commit('FORGET_ID')
      commit('FORGET_DATA')
      commit('REMEMBER_ID', payload)
      await axios
        .get(
          MarketplaceConfig.api.marketplaceBuyerProfile(payload),
          ApiConfig.options
        )
        .then((res) => {
          commit('REMEMBER_DATA', res.data.data)
          commit('STATUS_SUCCEEDED')
          return res
        })
        .catch((err) => {
          commit('STATUS_FAILED')
          throw new Error(err)
        })
        .finally(() => {
          commit('STATUS_IDLE')
        })
    },
    saveData({ commit }, payload) {
      commit('STATUS_BUSY')
      commit('FORGET_DATA')

      commit('REMEMBER_DATA', payload)
      commit('STATUS_SUCCEEDED')
      commit('STATUS_IDLE')
    },
    saveId({ commit }, payload) {
      commit('STATUS_BUSY')
      commit('FORGET_ID')

      commit('REMEMBER_ID', payload)

      commit('STATUS_SUCCEEDED')
      commit('STATUS_IDLE')
    },
    saveStatus({ commit }, payload) {
      commit('STATUS_BUSY')
      console.warn({ status: payload })
      const whitelist = ['H', 'A', 'D']
      if (whitelist.indexOf(payload) === -1) {
        commit('STATUS_FAILED')
        commit('STATUS_IDLE')
        return
      }

      commit('SAVE_STATUS', payload)

      commit('STATUS_SUCCEEDED')
      commit('STATUS_IDLE')
    },
    saveBalance({ commit }, payload) {
      commit('SAVE_BALANCE', payload)
    },
  },
}
